import React from "react";

// 3rd Party Library
import PropTypes from "prop-types";

//Styles
import styles from "./style.module.scss";

const CustomTabBtns = (props) => {
  const { data, activeIndex, onButtonClick } = props;

  return (
    <>
      <div className="p-0-5">
        {data.map((data, index) => (
          <button
            key={index}
            className={
              index === activeIndex
                ? `${styles.Tab_btn} ${styles.active}`
                : styles.Tab_btn
            }
            onClick={() => onButtonClick(index)}
          >
            {data.text}
          </button>
        ))}
      </div>
    </>
  );
};
CustomTabBtns.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeIndex: PropTypes.number.isRequired,
  onButtonClick: PropTypes.func.isRequired,
};

CustomTabBtns.defaultProps = {
  data: [],
  onButtonClick: () => {},
};
export default React.memo(CustomTabBtns);



